module.exports = __webpack_public_path__ + "static/img/93725bd9d1c34391ba499f65d6f4de96_mergeImage.2905a0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/93725bd9d1c34391ba499f65d6f4de96_mergeImage.png
// module id = Sg95
// module chunks = 1